import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=a2a84ca6&scoped=true&"
import script from "./Statistics.vue?vue&type=script&lang=js&"
export * from "./Statistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2a84ca6",
  null
  
)

export default component.exports